export const PRICELIMIT = 3000;
export const PAGESIZE = 25;

export const OFFERSPERREQUEST = 200;
export const OFFERSATFIRSTREQUEST = 50;

